import type { ColDef, GridOptions, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';

import { ItemListCell } from '~/components/common';

import { maskId, maskName } from '~/utils/common';

import type { TypeOrders } from '~/types/order.types';

/**
 * [반품 교환 관리] 반품/교환 신청 등록 모달 > 반품/교환 주문 선택 > 테이블 컬럼 정의
 */
const getClaimRegisterOrdersColumnDefs = () => {
  const gridOptions: GridOptions = {
    rowSelection: 'single',
  };

  const columnDefs: ColDef<TypeOrders>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
      checkboxSelection: true,
    },
    {
      field: 'order.clientOrderCode',
      headerName: '판매처 주문번호',
      width: 160,
    },
    {
      field: 'outbound.outboundCode',
      headerName: '출고요청번호',
      width: 164,
    },
    {
      field: 'delivery.deliveryDate',
      headerName: '배송예정일',
      width: 100,
      valueFormatter: ({ value }: ValueFormatterParams<TypeOrders, TypeOrders['delivery']['deliveryDate']>) =>
        value ? value.replaceAll('-', '.') : '-',
    },
    {
      field: 'delivery.operation.name',
      headerName: '배송유형',
      width: 80,
    },
    {
      field: 'delivery.courier.name',
      headerName: '배송사',
      width: 88,
    },
    {
      field: 'outbound.clusterCenter.name',
      headerName: '생산센터',
      width: 80,
    },
    {
      field: 'order.orderStoreName',
      headerName: '판매처',
      width: 148,
    },
    {
      field: 'order.paymentAt',
      headerName: '결제완료일시',
      width: 160,
      valueFormatter: ({ value }: ValueFormatterParams<TypeOrders, TypeOrders['order']['paymentAt']>) =>
        value ? value.replaceAll('-', '.') : '-',
    },
    {
      field: 'receiver.name',
      headerName: '수령자명',
      width: 100,
      valueFormatter: ({ value }: ValueFormatterParams<TypeOrders, TypeOrders['receiver']['name']>) => maskName(value),
    },
    {
      field: 'orderer.id',
      headerName: '주문자 ID',
      width: 140,
      valueFormatter: ({ value }: ValueFormatterParams<TypeOrders, TypeOrders['orderer']['id']>) => maskId(value),
    },
    {
      headerName: '상품명',
      minWidth: 240,
      flex: 1,
      cellRenderer: ItemListCell,
      cellRendererParams: ({ data }: ICellRendererParams<TypeOrders, TypeOrders['order']['orderItems']>) => ({
        value: data?.order?.orderItems ?? [],
        fieldName: 'itemName',
      }),
      cellStyle: { overflow: 'hidden', whiteSpace: 'normal' },
    },
  ];

  return { columnDefs, gridOptions };
};

export default getClaimRegisterOrdersColumnDefs;
